import React from 'react'
import GenericIcon from 'components/GenericIcon'

class Header extends React.Component {
  render() {
    const {
      collapsableId,
      title,
      iconName,
    } = this.props

    return(
      <div
        className='card-header'
        data-toggle='collapse'
        href={`#${collapsableId}`}
        role='button'
        aria-expanded='false'
        aria-controls={ collapsableId }
      >
        <div className='media mt-1 mb-1'>
          <div className='media-image mr-3 align-self-top'>
            <GenericIcon name={ iconName } />
          </div>
          <div className='media-body'>
            { title }
          </div>
          <div className='pull-right align-self-center btn-icon'>
            <div className='material-icons'>chevron_right</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Header;
